import { memo } from "react";
import { Button, Div, PageHeader, useTheme } from "react-better-html";

import { useReduxAction, useReduxState } from "../../../utils/hooks";
import { useI18n } from "../../../utils/i18n";

import AccountSection from "./AccountSection";
import PersonalInfoSection from "./PersonalInfoSection";
import SignInSecuritySection from "./SignInSecuritySection";
import DataPrivacySection from "./DataPrivacySection";
import DeleteAccountSection from "./DeleteAccountSection";

function Account() {
   const theme = useTheme();
   const { t } = useI18n();

   const firebaseUser = useReduxState((state) => state.user.firebaseUser);

   const logout = useReduxAction((actions) => actions.user.logout);

   return firebaseUser ? (
      <>
         <PageHeader
            title={t((l) => l.pages.account.title)}
            titleAs="h2"
            rightElement={
               <Button.destructive icon="logout" text={t((l) => l.pages.account.logOut)} onClick={logout as any} />
            }
            marginBottom={theme.styles.space}
         />

         <Div.column gap={theme.styles.space}>
            <AccountSection />
            <PersonalInfoSection />
            <SignInSecuritySection />
            <DataPrivacySection />
            <DeleteAccountSection />
         </Div.column>
      </>
   ) : undefined;
}

export default memo(Account);
